import PatientSocialNameInfoIcon from '@/components/patient-social-name-info-icon/index.vue'

export default {
  name: 'dicom-plus-modal-tab-paciente',
  inject: ['dicomPlusModal'],
  components: {
    PatientSocialNameInfoIcon
  },
  computed: {
    m() {
      return this.dicomPlusModal
    },
    isSocialNameEditable() {
      return this.m.isPatientEditable && !this.m.isGestorSaudeDisabled && !this.m.isExameDuplicate
    }
  }
}
